import Faq from 'components/Faq'
import sortBy from 'lodash/sortBy'

import { CateringFoodTypeQuery } from '../types/query'

type Props = {
  foodTypePage: NonNullable<CateringFoodTypeQuery['foodTypePage']>
}

const FaqSection = ({ foodTypePage }: Props) => {
  return (
    <div>
      <Faq
        className="bg-gray-50"
        faqs={sortBy(foodTypePage.faqSections, 'position').map((s) => ({
          // eslint-disable-next-line react/no-danger
          answer: <div dangerouslySetInnerHTML={{ __html: s.content.html }} />,
          question: s.title
        }))}
        title="Food Truck FAQ"
      />
    </div>
  )
}

export default FaqSection
